import React from "react";
import Divider from "@mui/material/Divider";

const FullWidthHorizontalDivider = (props) => (
  <Divider variant="fullWidth" {...props} />
);

export default FullWidthHorizontalDivider;
